import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { StyledContainerColumnLeft, StyledContainerRowStart } from '../../../styles/ContainerStyles'

type Props = {
  isNewEmployment: boolean
  employeeName?: string
}

const EmploymentFormDialogTitle = ({ isNewEmployment, employeeName }: Props) => {
  const { t } = useTranslation()

  return (
    <StyledContainerRowStart>
      <StyledContainerColumnLeft sx={{ width: { xs: '100%', sm: '75%', md: '75%' } }}>
        <Typography variant="h4" color="text.highEmphasis" id="generate-report-dialog-title">
          {isNewEmployment ? t('page.employments.dialog.form.addTitle') : t('page.employments.dialog.form.editTitle')}
        </Typography>
        {employeeName && (
          <Typography variant="subtitle1" color="text.mediumEmphasis">
            {employeeName}
          </Typography>
        )}
      </StyledContainerColumnLeft>
    </StyledContainerRowStart>
  )
}

export default EmploymentFormDialogTitle
